export default {"src":"/_next/static/media/insuranceLogo1.c1a4bc1f.svg","height":40,"width":200,"blurWidth":0,"blurHeight":0};